export default "__VITE_ASSET__MefXVG7$__"